import { Link } from 'react-router-dom';

import { useT } from '../i18n/LanguageProvider';
import type { CaseStudy } from '../types/content';

interface Props {
  item: CaseStudy;
  /** Kompakt variant används i listor på startsidan. */
  compact?: boolean;
}

export default function CaseCard({ item, compact }: Props) {
  const t = useT();
  const details: Array<[string, string]> = [
    [t.caseCard.challenge, item.challenge],
    [t.caseCard.role, item.role],
    [t.caseCard.approach, item.approach],
    [t.caseCard.outcome, item.outcome]
  ];

  return (
    <article className="case-card" id={item.id}>
      <span className="level">{item.level === 1 ? t.caseCard.named : t.caseCard.anonymous}</span>
      <h3>{item.title}</h3>
      <p className="muted">{item.situation}</p>

      {!compact && (
        <>
          <dl>
            {details.map(([term, description]) => (
              <div key={term}>
                <dt>{term}</dt>
                <dd>{description}</dd>
              </div>
            ))}
          </dl>
          <div className="insight">
            <strong>{t.caseCard.insight}</strong>
            <span>{item.insight}</span>
          </div>
        </>
      )}

      <div className="case-foot">
        <div className="tag-row">
          {item.tags.map((tag) => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
        {item.serviceId && item.serviceTitle && (
          <Link className="textlink" to={`/tjanster#${item.serviceId}`}>
            {item.serviceTitle} →
          </Link>
        )}
      </div>
    </article>
  );
}
